<script>
const Comp1t3 = resolve => {
  import('comp/modules/transverse/Comp1t3.vue').then(module => resolve(module))
}
const Comp2t3 = resolve => {
  import('comp/modules/transverse/Comp2t3.vue').then(module => resolve(module))
}
const Comp3t3 = resolve => {
  import('comp/modules/transverse/Comp3t3.vue').then(module => resolve(module))
}
const Comp4t3 = resolve => {
  import('comp/modules/transverse/Comp4t3.vue').then(module => resolve(module))
}
const Comp5t3 = resolve => {
  import('comp/modules/transverse/Comp5t3.vue').then(module => resolve(module))
}
const Comp6t3 = resolve => {
  import('comp/modules/transverse/Comp6t3.vue').then(module => resolve(module))
}
const Comp7t3 = resolve => {
  import('comp/modules/transverse/Comp7t3.vue').then(module => resolve(module))
}
const Comp8t3 = resolve => {
  import('comp/modules/transverse/Comp8t3.vue').then(module => resolve(module))
}
const Comp9t3 = resolve => {
  import('comp/modules/transverse/Comp9t3.vue').then(module => resolve(module))
}
const Comp10t3 = resolve => {
  import('comp/modules/transverse/Comp10t3.vue').then(module => resolve(module))
}
const Comp11t3 = resolve => {
  import('comp/modules/transverse/Comp11t3.vue').then(module => resolve(module))
}
const Comp12t3 = resolve => {
  import('comp/modules/transverse/Comp12t3.vue').then(module => resolve(module))
}
const Comp13t3 = resolve => {
  import('comp/modules/transverse/Comp13t3.vue').then(module => resolve(module))
}
const Comp14t3 = resolve => {
  import('comp/modules/transverse/Comp14t3.vue').then(module => resolve(module))
}
const Comp15t3 = resolve => {
  import('comp/modules/transverse/Comp15t3.vue').then(module => resolve(module))
}
const Comp16t3 = resolve => {
  import('comp/modules/transverse/Comp16t3.vue').then(module => resolve(module))
}
const Comp17t3 = resolve => {
  import('comp/modules/transverse/Comp17t3.vue').then(module => resolve(module))
}
const Comp18t3 = resolve => {
  import('comp/modules/transverse/Comp18t3.vue').then(module => resolve(module))
}
const Comp19t3 = resolve => {
  import('comp/modules/transverse/Comp19t3.vue').then(module => resolve(module))
}
const Comp21t3 = resolve => {
  import('comp/modules/transverse/Comp21t3.vue').then(module => resolve(module))
}

/* ------------------- 1/2 modules --------------------- */
const Comp22t2 = resolve => {
  import('comp/modules/transverse/Comp22t2.vue').then(module => resolve(module))
}
const Comp23t2 = resolve => {
  import('comp/modules/transverse/Comp23t2.vue').then(module => resolve(module))
}
const Comp24t2 = resolve => {
  import('comp/modules/transverse/Comp24t2.vue').then(module => resolve(module))
}
const Comp25t2 = resolve => {
  import('comp/modules/transverse/Comp25t2.vue').then(module => resolve(module))
}
const Comp26t2 = resolve => {
  import('comp/modules/transverse/Comp26t2.vue').then(module => resolve(module))
}
const Comp27t2 = resolve => {
  import('comp/modules/transverse/Comp27t2.vue').then(module => resolve(module))
}
const Comp28t2 = resolve => {
  import('comp/modules/transverse/Comp28t2.vue').then(module => resolve(module))
}
const Comp29t2 = resolve => {
  import('comp/modules/transverse/Comp29t2.vue').then(module => resolve(module))
}
const Comp30t2 = resolve => {
  import('comp/modules/transverse/Comp30t2.vue').then(module => resolve(module))
}
const Comp31t2 = resolve => {
  import('comp/modules/transverse/Comp31t2.vue').then(module => resolve(module))
}

/* vertical 1/3 modules */
const Comp32t3 = resolve => {
  import('comp/modules/transverse/Comp32t3.vue').then(module => resolve(module))
}

const Comp43t2 = resolve => {
  import('comp/modules/transverse/Comp43t2.vue').then(module => resolve(module))
}
const Comp45t2 = resolve => {
  import('comp/modules/transverse/Comp45t2.vue').then(module => resolve(module))
}
const Comp42t2 = resolve => {
  import('comp/modules/transverse/Comp42t2.vue').then(module => resolve(module))
}
const Comp44t2 = resolve => {
  import('comp/modules/transverse/Comp44t2.vue').then(module => resolve(module))
}
const Comp46t2 = resolve => {
  import('comp/modules/transverse/Comp46t2.vue').then(module => resolve(module))
}
const Comp47t2 = resolve => {
  import('comp/modules/transverse/Comp47t2.vue').then(module => resolve(module))
}
const Comp48t2 = resolve => {
  import('comp/modules/transverse/Comp48t2.vue').then(module => resolve(module))
}
const Comp49t2 = resolve => {
  import('comp/modules/transverse/Comp49t2.vue').then(module => resolve(module))
}

const Comp50t2 = resolve => {
  import('comp/modules/transverse/Comp50t2.vue').then(module => resolve(module))
}
const Comp51t2 = resolve => {
  import('comp/modules/transverse/Comp51t2.vue').then(module => resolve(module))
}
const Comp52t3 = resolve => {
  import('comp/modules/transverse/Comp52t3.vue').then(module => resolve(module))
}
const Comp53t3 = resolve => {
  import('comp/modules/transverse/Comp53t3.vue').then(module => resolve(module))
}
const Comp54t3 = resolve => {
  import('comp/modules/transverse/Comp54t3.vue').then(module => resolve(module))
}
const Comp55t3 = resolve => {
  import('comp/modules/transverse/Comp55t3.vue').then(module => resolve(module))
}

const Comp58t2 = resolve => {
  import('comp/modules/transverse2/Comp58t2.vue').then(module => resolve(module))
}
const Comp59t2 = resolve => {
  import('comp/modules/transverse2/Comp59t2.vue').then(module => resolve(module))
}
const Comp60t2 = resolve => {
  import('comp/modules/transverse2/Comp60t2.vue').then(module => resolve(module))
}
const Comp61t2 = resolve => {
  import('comp/modules/transverse2/Comp61t2.vue').then(module => resolve(module))
}
const Comp62t2 = resolve => {
  import('comp/modules/transverse2/Comp62t2.vue').then(module => resolve(module))
}
const Comp63t2 = resolve => {
  import('comp/modules/transverse2/Comp63t2.vue').then(module => resolve(module))
}
const Comp64t3 = resolve => {
  import('comp/modules/transverse2/Comp64t3.vue').then(module => resolve(module))
}
const Comp65t3 = resolve => {
  import('comp/modules/transverse2/Comp65t3.vue').then(module => resolve(module))
}
const Comp66t3 = resolve => {
  import('comp/modules/transverse2/Comp66t3.vue').then(module => resolve(module))
}

export default {
  name: 'LoadOnDemand',
  components: {
    Comp1t3, Comp2t3, Comp3t3, Comp4t3, Comp5t3, Comp6t3, Comp7t3, Comp8t3, Comp9t3, Comp10t3,
    Comp11t3, Comp12t3, Comp13t3, Comp14t3, Comp15t3, Comp16t3, Comp17t3, Comp18t3, Comp19t3,
    Comp21t3,

    Comp22t2, Comp23t2, Comp24t2, Comp25t2, Comp26t2, Comp27t2, Comp28t2, Comp29t2, Comp30t2,
    Comp31t2,
    Comp32t3,
    Comp43t2, Comp45t2, Comp42t2, Comp44t2, Comp46t2, Comp47t2, Comp48t2, Comp49t2,
    Comp50t2, Comp51t2, Comp52t3, Comp53t3, Comp54t3, Comp55t3,
    Comp58t2, Comp59t2, Comp60t2, Comp61t2, Comp62t2, Comp63t2, Comp64t3, Comp65t3, Comp66t3 },
  props: {
    pageDataObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  methods: {
    optionFilter(id) {
      return this.pageDataObj && Number(this.pageDataObj.id) === id
    },
    onComp32Click(subModuleName) {
      this.$emit('onComp32Click', subModuleName)
    },

    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div>
    <Comp1t3 v-if="optionFilter(1)" :module-option="pageDataObj" />
    <Comp2t3 v-if="optionFilter(2)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp3t3 v-if="optionFilter(3)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp4t3 v-if="optionFilter(4)" :module-option="pageDataObj" />
    <Comp5t3 v-if="optionFilter(5)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp6t3 v-if="optionFilter(6)" :module-option="pageDataObj" />
    <Comp7t3 v-if="optionFilter(7)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp8t3 v-if="optionFilter(8)" :module-option="pageDataObj" />
    <Comp9t3 v-if="optionFilter(9)" :module-option="pageDataObj" />
    <Comp10t3 v-if="optionFilter(10)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp11t3 v-if="optionFilter(11)" :module-option="pageDataObj" />
    <Comp12t3 v-if="optionFilter(12)" :module-option="pageDataObj" />
    <Comp13t3 v-if="optionFilter(13)" :module-option="pageDataObj" />
    <Comp14t3 v-if="optionFilter(14)" :module-option="pageDataObj" />
    <Comp15t3 v-if="optionFilter(15)" :module-option="pageDataObj" />
    <Comp16t3 v-if="optionFilter(16)" :module-option="pageDataObj" />
    <Comp17t3 v-if="optionFilter(17)" :module-option="pageDataObj" />
    <Comp18t3 v-if="optionFilter(18)" :module-option="pageDataObj" />
    <Comp19t3 v-if="optionFilter(19)" :module-option="pageDataObj" />
    <Comp21t3 v-if="optionFilter(21)" :module-option="pageDataObj" />

    <Comp22t2 v-if="optionFilter(22)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp23t2 v-if="optionFilter(23)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp24t2 v-if="optionFilter(24)" :module-option="pageDataObj" />
    <Comp25t2 v-if="optionFilter(25)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp26t2 v-if="optionFilter(26)" :module-option="pageDataObj" />
    <Comp27t2 v-if="optionFilter(27)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp28t2 v-if="optionFilter(28)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp29t2 v-if="optionFilter(29)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp30t2 v-if="optionFilter(30)" :module-option="pageDataObj" />
    <Comp31t2 v-if="optionFilter(31)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />

    <Comp32t3 v-if="optionFilter(32)" :module-option="pageDataObj" />

    <Comp42t2 v-if="optionFilter(42)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp43t2 v-if="optionFilter(43)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp44t2 v-if="optionFilter(44)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp45t2 v-if="optionFilter(45)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp46t2 v-if="optionFilter(46)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp47t2 v-if="optionFilter(47)" :module-option="pageDataObj" />
    <Comp48t2 v-if="optionFilter(48)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp49t2 v-if="optionFilter(49)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />

    <Comp50t2 v-if="optionFilter(50)" :module-option="pageDataObj" />
    <Comp51t2 v-if="optionFilter(51)" :module-option="pageDataObj" />
    <Comp52t3 v-if="optionFilter(52)" :module-option="pageDataObj" />
    <Comp53t3 v-if="optionFilter(53)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp54t3 v-if="optionFilter(54)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp55t3 v-if="optionFilter(55)" :module-option="pageDataObj" />

    <Comp58t2 v-if="optionFilter(58)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp59t2 v-if="optionFilter(59)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp60t2 v-if="optionFilter(60)" :module-option="pageDataObj" />
    <Comp61t2 v-if="optionFilter(61)" :module-option="pageDataObj" />
    <Comp62t2 v-if="optionFilter(62)" :module-option="pageDataObj" />
    <Comp63t2 v-if="optionFilter(63)" :module-option="pageDataObj" />
    <Comp64t3 v-if="optionFilter(64)" :module-option="pageDataObj" @onModuleItem="onModuleItem" />
    <Comp65t3 v-if="optionFilter(65)" :module-option="pageDataObj" />
    <Comp66t3 v-if="optionFilter(66)" :module-option="pageDataObj" />
  </div>
</template>

<style lang="scss" scoped>

</style>
